import React from 'react';
import unionPay from 'assets/images/union-pay.svg';
import { SvgIconProps } from '@mui/material';

export const AfUnionPayIcon: React.FC<SvgIconProps> = () => {
  return <img src={unionPay} />;
};
